import { searchActionType } from 'constants/searchActionType';
export var runSearch = function (Post) {
    return {
        type: searchActionType.UPDATESEARCH,
        payload: Post
    };
};
export var addPosts = function (searchedPosts) {
    return {
        type: searchActionType.ADD_LIST_POST,
        payload: { searchedPosts: searchedPosts }
    };
};
export var addPost = function (uid, post) {
    return {
        type: searchActionType.ADD_POST,
        payload: { uid: uid, post: post }
    };
};
export var addFilter = function (uid, post, filter) {
    return {
        type: searchActionType.ADD_FILTERM,
        payload: { uid: uid, post: post, filter: filter }
    };
};
export var clearState = function () {
    return {
        type: searchActionType.CLEAR,
        payload: {}
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/searchActions.ts
// module id = 1361
// module chunks = 0 1 2 3 4